import { GamesBreadcrumb } from "./index";
import { PlayGameLink } from "./index";

export default function GoGameInfo() {
  return (
    <div className="p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="Go" />
      <h1 className="text-3xl font-bold mb-4 text-slate-900 dark:text-slate-100">Go</h1>
      <img
        src="/thumbnails/Go.png"
        alt="Go game screenshot"
        className="rounded-lg shadow mb-4 w-full max-w-md mx-auto bg-white dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">About Go</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Go is an ancient board game of strategy and territory control, originating in China over 2,500 years ago. The game is played on a grid of 19x19 lines, where two players take turns placing black and white stones with the goal of controlling the largest area of the board. Go is renowned for its deep strategic complexity despite its simple rules.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Go is usually played by 2 players, each taking turns to place stones on the board.</li>
          <li>The objective is to control the largest area of the board by surrounding empty points and capturing opponent stones.</li>
          <li>Stones are placed on the intersections of the grid lines, and once placed, they cannot be moved.</li>
          <li>The game ends when both players pass their turns consecutively, and the player with the most controlled territory wins.</li>
          <li>Understanding life and death of groups, as well as strategic positioning, is key to mastering Go.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">History</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Go is believed to have originated in China over 2,500 years ago, making it one of the oldest board games still played today. It spread to Japan and Korea, where it developed into the modern game we know today. Go has a rich cultural and historical significance in East Asia.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Strategy Tips</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Focus on controlling larger areas of the board rather than capturing individual stones.</li>
          <li>Pay attention to the balance between attacking and defending your groups.</li>
          <li>Think ahead and anticipate your opponent's moves to gain strategic advantage.</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Play Go</h2>
          <p className="text-gray-700 dark:text-gray-300">
          You can play Go for free with friends or other players right here on Game for a Laugh! No download or registration required.
        </p>   
        <PlayGameLink game="Go" />
      </section>
    </div>
  );
}
